import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001/api';

// Define the structured response format (kept for ChatSection imports)
export interface AIJsonResponse {
  conversation: string;
  document: string;
  toc: string;
  title: string;
  recommended_agent?: string;
  flags: {
    titleUpdated: boolean;
    documentUpdated: boolean;
    tocUpdated: boolean;
    activeAgent: string;
  };
}

interface Message {
  id: number;
  text: string;
  isUser: boolean;
}

interface Agent {
  _id?: string;
  name: string;
  description: string;
  siteUrl: string | string[];
  documents: string[];
  systemPrompt?: string;
}

// Main function to generate a response — delegates to backend
export async function generateResponse(
  messages: Message[],
  currentDocument: string = '',
  currentTOC: string = '',
  currentTitle: string = '',
  agent: Agent | null = null
): Promise<string> {
  try {
    const response = await axios.post<AIJsonResponse>(
      `${API_BASE_URL}/ai/generate`,
      {
        messages,
        currentDocument,
        currentTOC,
        currentTitle,
        agent,
      }
    );
    return JSON.stringify(response.data);
  } catch (error: any) {
    console.error('Error calling AI backend:', error);

    // Return error response in the same format the frontend expects
    return JSON.stringify({
      conversation:
        'There was an error communicating with the AI. Please try again later.',
      document: currentDocument || '',
      toc: currentTOC || '',
      title: currentTitle || '',
      flags: {
        titleUpdated: false,
        documentUpdated: false,
        tocUpdated: false,
        activeAgent: 'natural_agent',
      },
    });
  }
}
